import { Component, inject, Input } from '@angular/core';
import { IndicatorDataStore } from '../../../stores/indicatpr-data/indicator-data.state';
import { DataLayer } from '../../../models/data-layer';
import { Indicator } from '../../../models/indicator';
import { IndicatorData } from '../../../models/indicator-data';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { ChipModule } from 'primeng/chip';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DividerModule } from 'primeng/divider';
import { HeaderComponent } from '../../atoms/header/header.component';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { SharedModule } from 'primeng/api';
import { DataLayerType } from '../../../models/data-layer-type';

@Component({
  selector: 'app-confirm-lock-data',
  standalone: true,
  imports: [
    ButtonModule,
    CheckboxModule,
    ChipModule,
    ConfirmDialogModule,
    DividerModule,
    HeaderComponent,
    ScrollPanelModule,
    SharedModule,
  ],
  templateUrl: './confirm-lock-data.component.html',
  styleUrl: './confirm-lock-data.component.scss',
})
export class ConfirmLockDataComponent {
  readonly dataStore = inject(IndicatorDataStore);

  @Input() dataLayerType!: DataLayerType;
  @Input() dataLayer!: DataLayer;
  @Input() indicator!: Indicator;
  @Input() indicatorData!: IndicatorData;
}
